import { AxiosResponse } from "axios";
import { axiosWSPInstance } from "../AxiosWSPInterceptor";
import * as ApiUrls from "./ApiUrl.SETATypes";
import { SETATypes } from "../../Model/Dto/WSP/SETA";

export const SETATypesService = {
    getAll: (): Promise<AxiosResponse<SETATypes[]>> => axiosWSPInstance.get(ApiUrls.SETATypes),
    getById: (setaTypeId: number): Promise<AxiosResponse<SETATypes>> => axiosWSPInstance.get(ApiUrls.SETATypes + setaTypeId)
}